'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* global $BV */

var loadBV = void 0;
var bvReviewsModalToggleEvent = void 0;
var BazaarVoiceInlineWrapper = function (_React$Component) {
  _inherits(BazaarVoiceInlineWrapper, _React$Component);
  function BazaarVoiceInlineWrapper() {
    _classCallCheck(this, BazaarVoiceInlineWrapper);
    var _this = _possibleConstructorReturn(this, (BazaarVoiceInlineWrapper.__proto__ || Object.getPrototypeOf(BazaarVoiceInlineWrapper)).call(this));
    _this.ratingsLoaded = false;
    _this.loadRatings = _this.loadRatings.bind(_this);
    return _this;
  }
  _createClass(BazaarVoiceInlineWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      if (!bvReviewsModalToggleEvent) {
        bvReviewsModalToggleEvent = new Event('bvReviewsModalToggle');
      }
      if (!loadBV) {
        loadBV = new Promise(function (resolve) {
          var tag = document.createElement('script');
          tag.src = 'https://display.ugc.bazaarvoice.com/static/' + _this2.props.brand.toLowerCase() + '/en_US/bvapi.js';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          window.onBazaarVoiceReady = function () {
            resolve(window.$BV);
          };
        });
      }
    }
  }, {
    key: 'loadRatings',
    value: function loadRatings() {
      $BV.ui('rr', 'inline_ratings', {
        productIds: this.props.products.map(function (product) {
          return product.slug;
        }),
        containerPrefix: 'BVRRInlineRating'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      if (typeof $BV !== 'undefined') {
        setTimeout(function () {
          return _this3.loadRatings();
        }, 0);
      } else {
        setTimeout(function () {
          _this3.render();
        }, 100);
      }
      return _react2.default.createElement('div', {
        className: 'bazaarvoice-inline-wrapper'
      }, this.props.children);
    }
  }]);
  return BazaarVoiceInlineWrapper;
}(_react2.default.Component);
BazaarVoiceInlineWrapper.propTypes = {
  brand: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node.isRequired,
  products: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    slug: _propTypes2.default.string
  })).isRequired
};
exports.default = BazaarVoiceInlineWrapper;